import React from 'react'

import { P, useT } from '@guiker/react-framework'

export const ReservationDisclosure: React.FC = () => {
  const { tShared } = useT({ domain: 'fractionalOwnership', entity: 'reservationDisclosure' })
  return <P>{tShared('content')}</P>
}
